import { render } from "./HjpTabView.vue?vue&type=template&id=4f77a074&ts=true"
import script from "./HjpTabView.vue?vue&type=script&lang=ts"
export * from "./HjpTabView.vue?vue&type=script&lang=ts"

import "./HjpTabView.vue?vue&type=style&index=0&id=4f77a074&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__